export interface CourseCategory{
  _id : string;
  name : string;
  parent : string | null ;
}
